import { env } from '@/lib/env';

/**
 * The base URL of the API, without the `/v1` prefix or a trailing slash — the
 * same value the axios client is built from.
 */
const API_BASE = env.VITE_API_URL.replace(/\/+$/, '');

/**
 * The Google OAuth entry point (spec R7.1).
 *
 * A full-page navigation, not an axios call: the browser has to *leave* for
 * Google's consent screen and come back, and an XHR to a cross-origin redirect
 * would be blocked and could carry no cookie back anyway. So this deliberately
 * sets `window.location` rather than going through the client.
 */
export const signIn = (): void => {
  window.location.href = `${API_BASE}/v1/auth/google`;
};
